module.exports = __webpack_public_path__ + "img/hr-green-croton-16.b17941a0.png";